export class BaseObject {

  public createdDate: number;
  public modifiedDate: number;
  public userId: string;


}




// WEBPACK FOOTER //
// ./src/app/shared/baseClass.ts